/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useState, Fragment, useRef, useLayoutEffect, useMemo, useEffect, useCallback } from 'react'
import { string, func, arrayOf, shape, bool, number } from 'prop-types'
import debounce from 'lodash.debounce'
import BackDrop from '../back-drop'
import * as flags from './flags'
import downArrow from './assets/down.svg'

const currentOptionIndex = (optionsList, titleName) => {
  let index = 0
  optionsList.forEach((list, i) => {
    if (list.name === titleName) {
      index = i
    }
  })
  return index
}

const FlagDropdown = ({
  titleCode,
  titleFlag,
  titleName,
  list: optionsList,
  setCountryFlag,
  setCountryCode,
  setPhoneNumber,
  setIsNumberValid,
  className,
  isLogin,
  isSigninDetail
}) => {
  // States
  const [isOptionsOpen, setIsOptionsOpen] = useState(false)
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(currentOptionIndex(optionsList, titleName))
  const [headerCode, setheaderCode] = useState(titleCode)
  const [headerFlag, setheaderFlag] = useState(titleFlag)
  const [headerName, setheaderName] = useState(titleName)
  const [listButtonEventKey, setListButtonEventKey] = useState('')
  const [listButtonKeyword, setListButtonKeyword] = useState('')

  const listRef = useRef()
  const dropDownListRef = useRef()

  useEffect(() => {
    isSigninDetail && listRef && listRef.current && listRef.current.focus()
  },[isSigninDetail])
  // Functions
  const closeDropDown = () => setIsOptionsOpen(false)
  const selectItem = (country) => {
    setheaderCode(`+${country.dialcode}`)
    setheaderFlag(country.iso2)
    setheaderName(country.name)
    setIsOptionsOpen(false)
    setCountryFlag(country.iso2)
    setCountryCode(`+${country.dialcode}`)
    setPhoneNumber('')
    setIsNumberValid(false)
  }

  const listCountrySearchHandler = (keyword) => {
    const countryByName = optionsList.find(list => list.name.toLowerCase().startsWith(keyword))
    if (countryByName) {
      selectItem(countryByName)
      setSelectedOptionIndex(currentOptionIndex(optionsList, countryByName.name))
    } else {
      const countryByCode = optionsList.find(list =>
        list.dialcode.toLowerCase().startsWith(keyword))
      if (countryByCode) {
        selectItem(countryByCode)
        setSelectedOptionIndex(currentOptionIndex(optionsList, countryByCode.name))
      }
    }
    setListButtonKeyword('')
  }
  const debouncedhandleListKeyDown = useMemo(() => debounce(listCountrySearchHandler, 300), [])

  const handleListKeyDown = (event) => {
    switch (event.type) {
      case 'click':
        event.preventDefault()
        setIsOptionsOpen(!isOptionsOpen)
        break
      case 'keydown':
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          setIsOptionsOpen(!isOptionsOpen)
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          setIsOptionsOpen(!isOptionsOpen)
          setListButtonEventKey(event.key)
        } else /* istanbul ignore else */ if (String.fromCharCode(event.keyCode).match(/[a-zA-Z0-9]/g)) {
          const newString = listButtonKeyword + String(event.key).toLowerCase()
          setListButtonKeyword(newString)
          debouncedhandleListKeyDown(newString)
        }
        break
      default:
    }
  }

  useLayoutEffect(() => {
    if (isOptionsOpen) {
      const listItems = dropDownListRef.current.childNodes
      if (listButtonEventKey === 'ArrowDown') {
        const nextIndex =
          selectedOptionIndex === optionsList.length - 1
            ? 0
            : selectedOptionIndex + 1
        setSelectedOptionIndex(nextIndex)
        setTimeout(() => {
          listItems[nextIndex].focus()
        }, 0)
      } else /* istanbul ignore else */ if (listButtonEventKey === 'ArrowUp') {
        const prevIndex =
          selectedOptionIndex - 1 >= 0
            ? selectedOptionIndex - 1
            : optionsList.length - 1
        setSelectedOptionIndex(prevIndex)
        setTimeout(() => {
          listItems[prevIndex].focus()
        }, 0)
      }
    }
  }, [listButtonEventKey])

  useLayoutEffect(() => {
    if (isOptionsOpen) {
      const listItems = dropDownListRef.current.childNodes
      listItems[selectedOptionIndex].focus()
    }
  }, [isOptionsOpen])

  const listItemCountrySearchHandler = (keyword) => {
    const listItems = dropDownListRef.current.childNodes
    const countryByName = optionsList.find(list => list.name.toLowerCase().startsWith(keyword))
    if (countryByName) {
      const newIndex = currentOptionIndex(optionsList, countryByName.name)
      setSelectedOptionIndex(newIndex)
      listItems[newIndex].focus()
    } else {
      const countryByCode = optionsList.find(list =>
        list.dialcode.toLowerCase().startsWith(keyword))
      if (countryByCode) {
        const newIndex = currentOptionIndex(optionsList, countryByCode.name)
        setSelectedOptionIndex(newIndex)
        listItems[newIndex].focus()
      }
    }
    setListButtonKeyword('')
  }
  const debouncedhandleListItemKeyDown = useMemo(() =>
    debounce(listItemCountrySearchHandler, 300), [])
  const handleListItemKeyDown = (e) => {
    e.preventDefault()
    const listItems = dropDownListRef.current.childNodes
    switch (e.key) {
      case 'Escape':
        setIsOptionsOpen(false)
        setSelectedOptionIndex(currentOptionIndex(optionsList, headerName))
        setListButtonEventKey('')
        listRef.current.focus()
        break
      case 'ArrowUp':
        const prevIndex =
          selectedOptionIndex - 1 >= 0
            ? selectedOptionIndex - 1
            : optionsList.length - 1
        setSelectedOptionIndex(prevIndex)
        listItems[prevIndex].focus()
        break
      case 'Tab':
      case 'ArrowDown':
        const nextIndex =
          selectedOptionIndex === optionsList.length - 1
            ? 0
            : selectedOptionIndex + 1
        setSelectedOptionIndex(nextIndex)
        listItems[nextIndex].focus()
        break
      case 'Home':
        setSelectedOptionIndex(0)
        listItems[0].focus()
        break
      case 'End':
        setSelectedOptionIndex(optionsList.length - 1)
        listItems[optionsList.length - 1].focus()
        break
      case 'Enter':
      case ' ':
        selectItem(optionsList[selectedOptionIndex])
        setIsOptionsOpen(!isOptionsOpen)
        listRef.current.focus()
        break
      default:
        break
    }

    // When user will type while listbox is open
    if (String.fromCharCode(e.keyCode).match(/[a-zA-Z0-9]/g)) {
      const newString = listButtonKeyword + String(e.key).toLowerCase()
      setListButtonKeyword(newString)
      debouncedhandleListItemKeyDown(newString)
    }
  }

  return (
    <div
      data-testid="dropdown-wrapper"
      className={`dropdown-wrapper ${className || ''}`}
    >
      <button
        className={`dropdown-header ${
          isOptionsOpen ? 'active' : 'closed'
        } ${className && `${className}-header`}`}
        data-testid="dropdown-header"
        tabIndex={isLogin ? 5 : 0}
        aria-label={`${headerName} ${headerCode}, Phone number country code.`}
        aria-haspopup="listbox"
        aria-expanded={isOptionsOpen}
        ref={listRef}
        onClick={handleListKeyDown}
        onKeyDown={handleListKeyDown}
      >
        <span aria-hidden="true" className="country-flag-ad">
          <img src={flags[headerFlag]} alt={headerCode} />
        </span>
        <span role="presentation" className="country-code">
          <span role="presentation" className="country-name">
            {headerName}
          </span>
          {headerCode}
        </span>
        <img
          aria-hidden="true"
          className="down-arrow"
          src={downArrow}
          alt="down-arrow"
          height="30"
          width="30"
        />
      </button>
      {isOptionsOpen && (
        <Fragment>
          <BackDrop onClick={closeDropDown} color="transparent" />
          <div className="list-wrapper" data-testid="list-wrapper">
            <ul
              ref={dropDownListRef}
              className="dropdown-list"
              onKeyDown={handleListItemKeyDown}
              tabIndex="-1"
              role="listbox"
            >
              {optionsList.map(item => (
                <li
                  className="dropdown-list-item"
                  id={item.iso2}
                  key={item.id}
                  onClick={() => selectItem(item)}
                  onKeyPress={() => selectItem(item)}
                  role="option"
                  tabIndex="0"
                  aria-label={`${item.name} +${item.dialcode}`}
                  aria-selected={item.name === headerName}
                >
                  <span
                    aria-hidden="true"
                    className={`country-flag-${item.iso2}`}
                  >
                    <img src={flags[item.iso2]} alt={item.name} />
                  </span>
                  <span role="presentation" className="country-name">
                    {item.name}
                  </span>
                  <span
                    role="presentation"
                    className="country-code"
                  >{`+${item.dialcode}`}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </Fragment>
      )}
    </div>
  )
}
FlagDropdown.propTypes = {
  titleCode: string,
  titleFlag: string,
  titleName: string,
  list: arrayOf(shape({
    id: number,
    iso2: string,
    name: string,
    dialcode: string,
  })),
  setCountryFlag: func,
  setCountryCode: func,
  setPhoneNumber: func,
  setIsNumberValid: func,
  className: string,
  isLogin: bool,
}

FlagDropdown.defaultProps = {
  titleCode: '44',
  titleFlag: 'gb',
  titleName: 'United Kingdom',
  list: [],
  setCountryFlag: x => x,
  setCountryCode: x => x,
  setPhoneNumber: x => x,
  setIsNumberValid: x => x,
  className: '',
  isLogin: false,
}
export default FlagDropdown
